import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';

const SEARCH_ENABLED = process.env.REACT_APP_FEATURE_SEARCH === 'true';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuToggleRef = useRef<HTMLButtonElement>(null);

  const closeAll = () => setMobileMenuOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setMobileMenuOpen(false);
        menuToggleRef.current?.focus();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [mobileMenuOpen]);

  return (
    <header className={`header${scrolled ? ' scrolled' : ''}`}>
      <nav className="nav">
        <Link to="/" className="logo" onClick={closeAll}>
          <picture>
            <source srcSet="/images/logos/jvp-logo.avif" type="image/avif" />
            <img src="/images/logos/jvp-logo.png" alt="JVP Health Tech Solutions" className="logo-image" />
          </picture>
          <span className="logo-text">JVP Health Tech Solutions</span>
        </Link>

        <button
          ref={menuToggleRef}
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
          aria-controls="primary-nav-links"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul id="primary-nav-links" className={`nav-links ${mobileMenuOpen ? 'nav-links-open' : ''}`}>
          <li><Link to="/" onClick={closeAll}>Home</Link></li>
          <li><Link to="/products" onClick={closeAll}>Products</Link></li>
          <li><Link to="/services" onClick={closeAll}>Services</Link></li>
          <li><Link to="/work" onClick={closeAll}>Our Work</Link></li>
          <li><Link to="/about" onClick={closeAll}>About Us</Link></li>
          {SEARCH_ENABLED && <li className="nav-search-item"><SearchBar /></li>}
          <li><Link to="/contact" className="contact-btn" onClick={closeAll}>Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;